import styled from "styled-components";

export const HighlightedDate = styled.p`
  width: 100%;
  color: ${(props) => (props?.isActive ? "#f48120" : "#6A7481")};
  line-height: 19px;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 0;
`;

export const Stroke = styled.div`
  width: 4px;
  background-color: ${(props) => (props?.isActive ? "#00BCF1" : "#DDE2E8")};
  height: ${(props) => props?.height ?? "100%"};
`;

export const Card = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;
  width: 100%;
  border-radius: 8px;
  gap: 8px;
  border: ${(props) =>
    props?.isActive ? "2px solid #00BCF1" : "2px solid #DDE2E8"};
  background-color: white;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  margin-left: ${(props) => props?.marginLeft ?? 0};
  cursor: ${(props) =>
    props?.isDone || props?.isActive ? "pointer" : "default"};
  @media only screen and (min-width: 768px) {
    min-width: 365px;
    max-width: 365px;
  }
`;

export const InnerCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TitleCard = styled.p`
  color: ${(props) =>
    props?.isDone ? "#0397C9" : props?.isActive ? "#00bcf1" : "#6A7481"};
  font-weight: ${(props) =>
    props?.isActive || props?.isDone ? "bold" : "normal"};
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 0;
`;

export const SubtitleCard = styled.p`
  color: #1f2d3d;
  line-height: 13px;
  font-weight: normal;
  font-size: 11px;
  margin-bottom: 0;
`;

export const Icon = styled.img`
  filter: ${(props) =>
    props?.isActive || props?.isDone ? "none" : "grayscale(1)"};
`;

export const Container = styled.div`
  flex-direction: column;
  display: flex;
  overflow: auto;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
  @media only screen and (min-width: 768px) {
    padding-top: 0px;
    padding-bottom: 0px;
  }
`;

export const Button = styled.button`
  display: flex;
  width: 100%;
  height: 44px;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  align-self: center;
  margin-top: 16px;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 40px;
  background-color: #00bcf1;
  @media only screen and (min-width: 768px) {
    max-width: 327px;
  }
`;
